import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

import { BlockedReasonsEnum } from "../../../../../shared/enums/blocked-reasons.enum";
import { JustificationsEnum } from "../../../../../shared/enums/justifications.enum";
import { UserProfileEnum } from "../../../../../shared/enums/user-profile.enum";
import { Utils } from "../../../../../shared/utils/utils";
import { selectLogon } from "../../state/selectors/user.selectors";

@Component({
    selector: "pl-info-card",
    templateUrl: "./info-card.component.html",
    styleUrls: ["./info-card.component.scss"],
    standalone: false
})
export class InfoCardComponent {
  @Input() showStatusBar = true;

  public selectedLogon$: Observable<any>;

  constructor(private readonly store: Store) {
    this.selectedLogon$ = this.store.select(selectLogon);
  }

  public getTranslatedProfile(logon: any): string {
    if (logon?.isSystemic) {
      return UserProfileEnum.SYSTEMIC;
    }
    type UserProfileKeys = keyof typeof UserProfileEnum;
    return UserProfileEnum[logon?.profile as UserProfileKeys] || "";
  }

  public getTranslatedReason(reason: string): string {
    type BlockedReasonsKeys = keyof typeof BlockedReasonsEnum;
    return Utils.translateReason(reason as BlockedReasonsKeys);
  }

  public getTranslatedJustification(justification: string): string {
    type JustificationsKeys = keyof typeof JustificationsEnum;
    if (justification) {
      return ` - ${Utils.translateJustification(
        justification as JustificationsKeys,
      )}`;
    }
    return "";
  }

  public userIsBlocked(status: string | undefined): boolean {
    status = status ? status.trim() : "";
    return status === "BLOCKED";
  }
}
